import productCategoryFilter from 'html/addon/product-category-filter.html';
import App from 'app/app.js';
import 'app/store/ContentStore.js';
import 'app/action/ContentChangeAction.js';

function LtProductCategoryFilterDirective(
  ContentStore,
  ContentChangeAction,
  $timeout,
  $location,
  $window,
  $anchorScroll,
  RouterService,
  AnalyticsService
) {
  return {
    restrict: 'E',
    scope: {
      selectedCategory: '=',
      productCategories: '=',
      selectedProduct: '=',
      hasSuggestedProducts: '='
    },
    template: productCategoryFilter,
    link: function (scope, element, attrs) {
      var selectFirstCategory = true,
        ADDON_PATH = '/addon';
      scope.selectedProductIndex = -2;
      scope.leftButtonActive = false;
      scope.rightButtonActive = true;

      var updateContent = function () {
        var contentProductCategories = ContentStore.getProductCategories(),
          mapper = R.map(function (productCategory) {
            var image = ContentStore.getContent(null, 'Product_Category_Image_' + productCategory),
              contentProductCategory;
            R.forEach(function (productCategoryObj) {
              if (productCategoryObj.code.toLowerCase() === ('Product_Category_' + productCategory).toLowerCase()) {
                contentProductCategory = productCategoryObj;
              }
            })(contentProductCategories);
            if (!!productCategory && !!contentProductCategory) {
              return {
                category: productCategory,
                label: contentProductCategory.contentItem,
                image: image,
                sortNumber: contentProductCategory.sortNumber
              };
            }
          }),
          sorter = R.sort(function (a, b) {
            // force convert image value to boolean - has to put it in a var
            if (R.isNil(a.image) === R.isNil(b.image)) {
              return a.sortNumber - b.sortNumber;
            }

            return !!a.image ? -1 : 1;
          }),
          allItemsSheet = {
            category: null,
            label: 'All Items',
            image: '',
            sortNumber: 0
          },
          productCategories = R.pipe(
            mapper,
            sorter,
            R.prepend(allItemsSheet)
          )(scope.productCategories).filter(function (element) {
            return element !== undefined;
          });
        scope.productCategoryWithImageList = R.takeWhile(function (productCategory) {
          return !!productCategory.image || productCategory.category === null;
        })(productCategories);

        if (!!selectFirstCategory && !!scope.productCategories.length) {
          scope.selectedCategory = productCategories[0].category;
          scope.selectedProduct = productCategories[0].label;
          scope.selectedProductIndex = 0;
          selectFirstCategory = false;
        }
      };

      var unbinder = ContentChangeAction.register(updateContent.bind(this));
      updateContent();

      scope.selectCategory = function (productCategory, position) {
        scope.selectedProductIndex = position;
        scope.selectedCategory = productCategory.category;
        scope.selectedProduct = productCategory.label;
        AnalyticsService.recordActiveAddOnCategory(productCategory.label);
      };

      var calcButtons = function () {
        var container = $('#carousel-product-category .category-container');

        if (container) {
          scope.leftButtonActive = container.scrollLeft() !== 0;

          var maxScrollLeft = container[0].scrollWidth - container.innerWidth();
          scope.rightButtonActive = container.scrollLeft() !== maxScrollLeft;
        }
      };

      var scrollContainer = function (leftVal) {
        var container = $('#carousel-product-category .category-container');
        if (!!container) {
          container.scrollLeft(leftVal);
          calcButtons();
        }
      };

      scope.prevPage = function () {
        scrollContainer(-625);
      };

      scope.nextPage = function () {
        scrollContainer(625);
      };

      scope.$on(
        '$destroy',
        function () {
          unbinder();
        }.bind(this)
      );
    }
  };
}

App.directive('ltProductCategoryFilter', [
  'ContentStore',
  'ContentChangeAction',
  '$timeout',
  '$location',
  '$window',
  '$anchorScroll',
  'RouterService',
  'AnalyticsService',
  LtProductCategoryFilterDirective
]);
